module.exports = __webpack_public_path__ + "img/404.c3367f60.png";